import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import FilterIcon from '../../assets/images/icons/filter.svg'
import CustomImage from '../CustomImage'
import FilterListIcon from '@material-ui/icons/FilterList'

import React, { useState } from 'react'
import CustomFilter from '../CustomFilter'
import FilterPopup from '../Dialog/FilterPopup'
import { ShowPositionFilter, ShowStatusFilter } from '../FilterArray/FilterArray'

export default function CustomTableHeading({
  heading,
  filterOptions,
  headingFilter = 'Position',
  setPositionId,
  positionId,
  filterByPosition,
  filterParams,
  setFilterParams,
  columnSpan = {},
  headingOnClick = {},
  headingStyles = {},
  filterIcons = {},
}) {
  const [openPopup, setOpenPopup] = useState(false)
  const [openPosition, setOpenPosition] = useState(false)

  const handlePopup = () => {
    setOpenPopup(false)
  }

  return (
    <React.Fragment>
      <TableHead style={{ zIndex: 90 }}>
        <TableRow>
          {heading.map((item, index) => (
            <TableCell
              key={index}
              colspan={columnSpan[item]}
              onClick={headingOnClick[item]}
              style={{ cursor: headingOnClick[item] && 'pointer', ...headingStyles[item] }}
            >
              {' '}
              {item} {filterIcons && filterIcons[item]}
              {/* {headingOnClick[item] && <FilterListIcon />} */}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </React.Fragment>
  )
}
